import { getSessionValue, SessionKvKey } from "../../api/features/session-kv";
import { useSelector } from "react-redux";

export default function useSessionGetValue<T>(key: SessionKvKey) {
  return useSelector((state) => getSessionValue<T>(state, key));
}
